module.exports = __webpack_public_path__ + "img/ovm7690-r20a.952197f9.jpg";